'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useOAuth2ErrorTranslation } from '@/lib/oauth2';
import { OAuth2Card } from '../-components/OAuth2Card';
import { OAuth2ErrorContent } from '../-components/OAuth2ErrorContent';
import { OAuth2Screen } from '../-components/OAuth2Screen';
const SearchSchema = z.object({
  /** OAuth2 RFC 6749 / OIDC Core 準拠のエラーコード */
  error: z.string().optional(),
  /** Hydra (fosite) からのエラー詳細 (英文ハードコード) */
  error_description: z.string().optional(),
  /** Hydra の error hint (英文ハードコード) */
  error_hint: z.string().optional(),
  /** dev/debug 用補足情報 */
  error_debug: z.string().optional()
});
export const Route = createFileRoute('/oauth2/error/')({
  validateSearch: zodValidator(SearchSchema),
  component: OAuth2ErrorPage
});

/**
 * `/oauth2/error` ルート。Hydra Public が error redirect でフロントに飛ばす際の
 * 最終表示先。`useOAuth2ErrorTranslation` で `OAuth2ErrorCard` と同じ解決順序を使う。
 */
function OAuth2ErrorPage() {
  const {
    error,
    error_description,
    error_hint,
    error_debug
  } = Route.useSearch();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.oauth2.errors'
  });
  const {
    translateRedirectError
  } = useOAuth2ErrorTranslation();
  const mainMessage = translateRedirectError({
    errorCode: error,
    errorDescription: error_description
  });

  // dev/debug 情報: hint + debug を <details> に集約
  const debugDetails = [error_hint, error_debug].filter(Boolean).join('\n\n');
  return <OAuth2Screen>
      <OAuth2Card>
        <OAuth2ErrorContent message={mainMessage} code={error}>
          {debugDetails && <details className="w-full text-left">
              <summary className="cursor-pointer text-labelSmallReg text-neutral-muted-on-fill">
                {t('showDetails')}
              </summary>
              <pre className="mt-2 whitespace-pre-wrap break-all text-labelSmallReg text-neutral-muted-on-fill">
                {debugDetails}
              </pre>
            </details>}
        </OAuth2ErrorContent>
      </OAuth2Card>
    </OAuth2Screen>;
}